export default __webpack_public_path__ + "static/media/SWT0150.34I-21123_-14873_0.fa71687a.jpg";